import React from 'react';

export interface ChipOption<T extends string> {
    value: T;
    label: string;
}

export interface ChipGroupProps<T extends string> {
    label: string;
    value: T;
    options: ChipOption<T>[];
    onChange: (value: T) => void;
}

export function ChipGroup<T extends string>({ label, value, options, onChange }: ChipGroupProps<T>): JSX.Element {
    return (
        <div className={'vp-chips'} role={'radiogroup'} aria-label={label}>
            {options.map((o) => (
                <button
                    key={o.value}
                    type={'button'}
                    role={'radio'}
                    aria-checked={o.value === value}
                    className={`vp-chip${o.value === value ? ' vp-chip--on' : ''}`}
                    onClick={() => onChange(o.value)}
                >
                    {o.label}
                </button>
            ))}
        </div>
    );
}
